<title>Expertteam - Zoeken</title>
<app-headermenu></app-headermenu>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true,  primaryColour:'#63b5a2'}"></ngx-loading>

<div class="container container-zoeken">

  <h3>Taxaties zoeken</h3>
  <form [formGroup]="searchForm" class="container-fluid">
    <!-- Primary Identifiers Section -->
    <fieldset class="border p-3 mb-4 rounded">
      <legend class="w-auto px-2 fs-6 text-muted">Taxatiegegevens</legend>
      <div class="row mb-2">
        <div class="col-md-2">
          <input type="text" (keyup.enter)="search(1)" minlength="4" class="form-control form-control-sm"
            formControlName="taxnumber" placeholder="Taxatienummer">
        </div>

        <div class="col-md-2">
          <input type="text" (keyup.enter)="search(1)" minlength="4" class="form-control form-control-sm"
            formControlName="vin" placeholder="VIN nummer">
        </div>

        <div class="col-md-4">
          <input type="text" (keyup.enter)="search(1)" minlength="4" class="form-control form-control-sm"
            formControlName="license" placeholder="Kenteken">
        </div>
      </div>
    </fieldset>

    <!-- Separator: OF -->
    <div class="text-center my-3 position-relative">
      <hr class="w-100" />
      <span class="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted fw-semibold"
        style="font-size: 0.9rem; letter-spacing: 0.5px;">
        OF
      </span>
    </div>

    <!-- Advanced Filters Section -->
    <div class="card p-3 mb-4 shadow-sm">
      <h6 class="text-muted mb-3">Voertuigspecificaties</h6>

      <div class="row mb-3">
        <div class="col-md-4">
          <ng-select (change)="vehicleTypesUpdate($event)" [placeholder]="'Soort voertuig...'"
            formControlName="vehicleType">
            @for (type of VehicleTypes; track type) {
              <ng-option [value]="type.id">
                {{ type.descriptionNl | capitalize }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-4">
          <ng-select [placeholder]="'Merk...'" (change)="makesUpdate($event)" formControlName="make">
            @for (make of Makes; track make) {
              <ng-option [value]="make.make">
                {{ make.make | capitalize }}
              </ng-option>
            }
          </ng-select>
        </div>

        <div class="col-md-4">
          <ng-select
            [placeholder]="'Model...'"
            formControlName="model"
            [items]="Models"
            bindValue="modelSpecific"
            bindLabel="modelSpecific">
          </ng-select>
        </div>

        <div class="col-md-4">
          <ng-select [placeholder]="'Brandstof...'" formControlName="fuelType">
            @for (fuel of FuelTypes; track fuel) {
              <ng-option [value]="fuel.id">
                {{ fuel.descriptionNl | capitalize }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-2">
          <input type="number" class="form-control form-control-sm" formControlName="yearMin"
            placeholder="Bouwjaar (min)">
        </div>

        <div class="col-md-2">
          <input type="number" class="form-control form-control-sm" formControlName="yearMax"
            placeholder="Bouwjaar (max)">
        </div>

        <div class="col-md-4">
          <ng-select [placeholder]="'Transmissie...'" formControlName="transmission">
            @for (transmission of TransmissionTypes; track transmission) {
              <ng-option [value]="transmission.id">
                {{ transmission.descriptionNl | capitalize }}
              </ng-option>
            }
          </ng-select>
        </div>

        <div class="col-md-4">
          <ng-select [placeholder]="'Carrosserie...'" formControlName="bodyType">
            @for (body of BodyTypes; track body) {
              <ng-option [value]="body.name">
                {{ body.descriptionNl | capitalize }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="onlyInCurrentBidTerm"
              id="onlyInCurrentBidTerm">
            <label class="form-check-label" for="onlyInCurrentBidTerm">
              Alleen zoeken in huidige biedtermijn
            </label>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-check">
            <input class="form-check-input" formControlName="onlyMyVehicles" type="checkbox" id="onlyMyVehicles">
            <label class="form-check-label" for="onlyMyVehicles">
              Alleen zoeken in mijn voertuigen
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Buttons -->
  <div class="d-flex justify-content-end mt-3">
    <button (click)="reset()" type="button" class="btn btn-outline-secondary me-2">
      Reset formulier
    </button>
    <button (click)="isSearchingWithButton = true; search(1)" type="button" class="btn text-white"
      style="background-color: #d65d8c;">
      Zoeken <i class="fa fa-search ms-1" aria-hidden="true"></i>
    </button>
  </div>

  @if (SearchResults) {
    <div id="result">
      <br>
        <h3>Zoekresultaten</h3>
        @if (SearchResults) {
          <p>Uw zoekopdracht heeft
            <b>{{TotalResults}}</b> resultaten opgeleverd.
          </p>
        }
        <div id="searchResults" class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="hasOrdering" (click)="setOrder('id');">Taxatienr
                  @if (currentOrder[0].field == 'id' && currentOrder[0].direction == 'ASC') {
                    <span><i
                    class="fas fa-sort-down"></i></span>
                  }
                  @if (currentOrder[0].field == 'id' && currentOrder[0].direction == 'DESC') {
                    <span><i
                    class="fas fa-sort-up"></i></span>
                  }
                  @if (currentOrder[0].field != 'id') {
                    <span><i class="fas fa-sort"></i></span>
                  }
                </th>
                <th style="color:#d65d8c;">Kenteken</th>
                <th class="hasOrdering" (click)="setOrder('Vehicle.make');">Voertuig
                  @if (currentOrder[0].field == 'Vehicle.make' && currentOrder[0].direction == 'ASC') {
                    <span><i
                    class="fas fa-sort-down"></i></span>
                  }
                  @if (currentOrder[0].field == 'Vehicle.make' && currentOrder[0].direction == 'DESC') {
                    <span><i
                    class="fas fa-sort-up"></i></span>
                  }
                  @if (currentOrder[0].field != 'Vehicle.make') {
                    <span><i class="fas fa-sort"></i></span>
                  }
                </th>
                <th class="hasOrdering" (click)="setOrder('Vehicle.year');">Bouwjaar
                  @if (currentOrder[0].field == 'Vehicle.year' && currentOrder[0].direction == 'ASC') {
                    <span><i
                    class="fas fa-sort-down"></i></span>
                  }
                  @if (currentOrder[0].field == 'Vehicle.year' && currentOrder[0].direction == 'DESC') {
                    <span><i
                    class="fas fa-sort-up"></i></span>
                  }
                  @if (currentOrder[0].field != 'Vehicle.year') {
                    <span><i class="fas fa-sort"></i></span>
                  }
                </th>
                <th class="hasOrdering" (click)="setOrder('VehicleSpecification.mileage');">Tellerstand
                  @if (currentOrder[0].field == 'VehicleSpecification.mileage' && currentOrder[0].direction == 'ASC') {
                    <span
                      ><i
                    class="fas fa-sort-down"></i></span>
                  }
                  @if (currentOrder[0].field == 'VehicleSpecification.mileage' && currentOrder[0].direction == 'DESC') {
                    <span
                      ><i
                    class="fas fa-sort-up"></i></span>
                  }
                  @if (currentOrder[0].field != 'VehicleSpecification.mileage') {
                    <span><i class="fas fa-sort"></i></span>
                  }
                </th>
                <th style="color:#d65d8c;">Leverdatum</th>
                <th style="color:#d65d8c;">Mijn bod</th>
                <th style="color:#d65d8c;">Hoogste bod</th>
              </tr>
            </thead>
            @if (SearchResults == '') {
              <tbody>
                <tr>
                  <td>Geen resultaten gevonden.</td>
                  <td colspan="8"></td>
                </tr>
              </tbody>
            }
            @if (SearchResults) {
              <tbody>
                @for (data of SearchResults; track data) {
                  <tr (click)="navigateToDetail(data.id)">
                    <td>
                      <b>T{{data.id}}</b>
                    </td>
                    <td>{{data.VehicleSpecification.Vehicle.registration | licensePipe:
                    data.VehicleSpecification.Vehicle.registration}}</td>
                    <td>{{data.VehicleSpecification.Vehicle.make | capitalize}}
                      {{data.VehicleSpecification.Vehicle.modelSpecific |
                    capitalize}}</td>
                    <td>{{data.VehicleSpecification.Vehicle.year}}</td>
                    <td>{{data.VehicleSpecification.mileage | number | replace:',':'.'}}
                    {{data.VehicleSpecification.mileageType}}</td>
                    @if (data.dateDelivery != null) {
                      <td>{{(data | dateDelivery).date | date: 'dd-MM-yyyy'}}</td>
                    }
                    @if (data.BidList.MyBid != null) {
                      <td>€ {{data.BidList.MyBid.bid | number:'2.0-0':'nl'}}</td>
                    }
                    @if (data.BidList.MyBid == null) {
                      <td>Geen bod</td>
                    }
                    @if (data.highestExpertBid != null) {
                      <td>€ {{data.highestExpertBid | number:'2.0-0':'nl'}}</td>
                    }
                    @if (data.highestExpertBid == null) {
                      <td>Geen bod</td>
                    }
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
        <nav aria-label="Paginanummering">
          <ul class="pagination pagination-sm justify-content-center">
            <li style="color:#d65d8c;" class="page-item" [ngClass]="{disabled:currentPage === 1}">
              <a class="page-link" (click)="setPage(1)">
                <i class="fa fa-fast-backward" aria-hidden="true"></i>
              </a>
            </li>
            <li style="color:#d65d8c;" class="page-item" [ngClass]="{disabled:currentPage === 1}">
              <a class="page-link" (click)="setPage(currentPage - 1)">
                <i class="fa fa-backward" aria-hidden="true"></i>
              </a>
            </li>
            <li style="color:#d65d8c;" class="page-item">
              <div class="dropdown">
                <button style="border: 1px solid #dee2e6;" class="btn btn-sm btn-default dropdown-toggle" type="button"
                  id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  Pagina {{currentPage}} van {{totalPages}}
                </button>
                <ul id="dropdown-menu" class="dropdown-menu" aria-labelledby="dropdownMenu1">
                  <li> <input (keyup.enter)="navigateToPage()" type="number" class="form-control-sm form-control"
                  placeholder="Ga naar pagina..."></li>
                </ul>
              </div>
            </li>
            <li style="color:#d65d8c;" class="page-item" [ngClass]="{disabled:currentPage === totalPages}">
              <a class="page-link" class="page-link" (click)="setPage(currentPage + 1)">
                <i class="fa fa-forward" aria-hidden="true"></i>
              </a>
            </li>
            <li style="color:#d65d8c;" class="page-item" [ngClass]="{disabled:currentPage === totalPages}">
              <a class="page-link" (click)="setPage(totalPages)">
                <i class="fa fa-fast-forward" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    }
  </div>